import Card, { CardTitle } from "./Card";
import React, { useState } from "react";
import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "../../posts/constants";
import BarChart from "components/BarChart";
import CompareModal from "./CompareModal";
import { COLORS } from "utils/styles.js";
import { getAudienceEmoji } from "posts/constants";

export default function GenderCard({ activeAudience }) {
  const renderData = (audience) => {
    // Note: Color is added for the onMouseOver() function in DonutGraph component
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return [
          { x: "Male", y: 52 },
          { x: "Female", y: 46 },
          {
            x:
              "Non-Binary/\n\
                Third Gender/\n\
                Other",
            y: 0.5,
          },
          { x: "Prefer not to say", y: 1 },
        ];
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return [
          { x: "Male", y: 50 },
          { x: "Female", y: 48 },
          {
            x:
              "Non-Binary/\n\
                Third Gender/\n\
                Other",
            y: 1.25,
          },
          { x: "Prefer not to say", y: 1 },
        ];
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return [
          { x: "Male", y: 37 },
          { x: "Female", y: 60 },
          {
            x:
              "Non-Binary/\n\
                Third Gender/\n\
                Other",
            y: 2.2,
          },
          { x: "Prefer not to say", y: 1 },
        ];
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return [
          { x: "Male", y: 51 },
          { x: "Female", y: 47 },
          {
            x:
              "Non-Binary/\n\
                Third Gender/\n\
                Other",
            y: 0.5,
          },
          { x: "Prefer not to say", y: 1 },
        ];
    }
  };

  const renderColorScale = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return COLORS.TOUGH_COOKIES_PALETTE;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return COLORS.DONT_TREAD_ON_ME_PALETTE;
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return COLORS.PEOPLE_POWER_PALETTE;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return COLORS.IF_YOU_SAY_SO_PALETTE;
    }
  };

  const data = renderData(activeAudience);
  const colors = renderColorScale(activeAudience);

  const [showCompare, setShowCompare] = useState(false);

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Gender
      </CardTitle>

      <BarChart data={data} colors={colors} />

      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Gender</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`gender-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    <BarChart
                      data={renderData(type)}
                      colors={renderColorScale(type)}
                    />
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}
